import { createFileRoute } from "@tanstack/react-router";
import { ProductRouteError } from "@/session/product-route-frame";
import { OnboardingLoading } from "@softmax/product-ux/onboarding";
import { getSubmitPage } from "@/features/play/records";
import { SubmitPage } from "@/features/play/submit";

export const Route = createFileRoute("/_site/$coworld/submit")({
  loaderDeps: ({ search }) => search,
  loader: ({ location, abortController }) =>
    getSubmitPage({
      data: { href: location.href },
      signal: abortController.signal,
    }),
  staleTime: 0,
  gcTime: 0,
  pendingComponent: OnboardingLoading,
  errorComponent: ProductRouteError,
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData
          ? `${loaderData.spec.title} · ${loaderData.displayName} · Softmax`
          : "Submit · Softmax",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: loaderData
      ? [{ rel: "canonical", href: loaderData.canonicalHref }]
      : [],
  }),
  component: () => <SubmitPage data={Route.useLoaderData()} />,
});
